const programs = {
  gaushala: {
    hero: {
      badge: "Gau Seva & Protection",
      brand: "Vrindavan Gir Gaushala",
      title: "Serving and Protecting Gir Cows with Reverence",
      subtitle:
        "Dedicated to providing lifelong shelter, fresh green fodder, medical care, and a safe sanctuary for indigenous Gir cows, calves, and bulls.",
      primaryCta: "Support the Gaushala",
      secondaryCta: "Sponsor a Cow",
      imageAlt: "Indigenous Gir cows in clean sanctuary",
    },
    about: {
      eyebrow: "About the Gaushala",
      heading: "Rooted in Jeev Daya & Compassionate Care",
      tagline: "Gau Seva as a sacred form of humanitarian service.",
      body: "Our Vrindavan Gir Gaushala is dedicated to the care, protection, and lifelong shelter of indigenous Gir cows. Every animal receives wholesome green and dry fodder, continuous medical care, and a safe, clean environment. We believe in Gau Seva as an essential form of humanitarian service and Jeev Daya.",
      capacityTitle: "Current Shelter Capacity",
      capacityDesc: "Currently providing lifelong care and shelter to 250+ Gir cows, calves, and bulls.",
      expansionTitle: "Future Expansion Plans",
      expansionDesc: "Expanding facilities for 500+ cows with an upgraded veterinary clinic, solar shelter sheds, and enlarged organic grazing pastures.",
    },
    why: {
      eyebrow: "Why Support Us",
      heading: "Holistic Welfare for Every Cow",
      subtitle: "Your support ensures round-the-clock care, nutritious feed, and dignity for sacred Gir cows.",
      card1Title: "Daily Nutritious Fodder",
      card1Desc: "Fresh green grass, dry fodder, clover, and organic nutrient mixes provided daily.",
      card2Title: "Medical Care",
      card2Desc: "Dedicated veterinary team, routine health checkups, vaccinations, and 24/7 emergency care.",
      card3Title: "Safe Shelter",
      card3Desc: "Spacious, well-ventilated sheds designed for seasonal weather protection and comfort.",
      card4Title: "Clean Environment",
      card4Desc: "Hygienic premises, fresh water troughs, and daily cleaning for healthy living.",
      card5Title: "Lifetime Protection",
      card5Desc: "Lifelong sanctuary for elderly, non-milking, injured, and rescued animals.",
      card6Title: "Cow Welfare",
      card6Desc: "Pure Gau Seva rooted in compassion, respect, and traditional ethical practices.",
    },
    sponsorships: {
      eyebrow: "Sponsorship Programs",
      heading: "Choose Your Sponsorship Plan",
      subtitle: "Support fodder, medical care, and gaushala development through transparent programs.",
      sponsorNow: "Sponsor Now",
      popularBadge: "Most Popular",
      decadeBadge: "Featured Seva",
    },
    stats: {
      eyebrow: "Our Impact",
      heading: "Quantifiable Gau Seva Milestones",
      cowsSheltered: "Cows Sheltered",
      dailyMeals: "Daily Meals Provided",
      medicalCare: "Medical Care & Health",
      yearsOfService: "Years of Dedicated Service",
    },
    gallery: {
      eyebrow: "Gaushala Gallery",
      heading: "Glimpses of Care & Sanctuary",
      item1Title: "Gir Cows Resting",
      item1Desc: "Healthy Gir cows in clean open-air shaded shelter.",
      item2Title: "Morning Fodder Feed",
      item2Desc: "Distribution of fresh green fodder & nutrition.",
      item3Title: "Clean Shelter Sheds",
      item3Desc: "Spacious, hygienic, and well-ventilated premises.",
      item4Title: "Dedicated Volunteers",
      item4Desc: "Devotees & volunteers serving cows with love.",
      item5Title: "Veterinary Check-Up",
      item5Desc: "Routine medical care and health monitoring.",
      item6Title: "Playful Calves",
      item6Desc: "Young Gir calves in open sanctuary pastures.",
    },
    visit: {
      eyebrow: "Experience Gau Seva",
      heading: "Visit the Gaushala",
      subtitle: "Come spend peaceful moments in the presence of Gir cows. Feel the joy of Gau Seva, feeding cows, and participating in morning/evening Gau Aarti.",
      locationTitle: "Location",
      locationDesc: "Jivandhara Sanctuary Campus, Vrindavan Gir Gaushala, Gujarat",
      hoursTitle: "Visiting Hours",
      hoursDesc: "Open daily for visitors: 7:00 AM – 11:30 AM & 4:00 PM – 6:30 PM",
      planVisit: "Plan a Visit",
      contactUs: "Contact Gaushala Team",
    },
    faq: {
      eyebrow: "Got Questions?",
      heading: "Frequently Asked Questions",
      q1: "How can I sponsor a cow?",
      a1: "Select a sponsorship plan above (1 Year, 2 Years, 5 Years, 10 Years, or Daily Fodder Support) and click 'Sponsor Now' to complete your contribution securely online.",
      q2: "How is my donation used?",
      a2: "100% of your contribution goes towards purchasing fresh green fodder, dry feed, veterinary medicines, shed maintenance, and expanding shelter facilities.",
      q3: "Can I visit the Gaushala?",
      a3: "Yes! Visitors, families, and devotees are warmly welcome to visit daily during visiting hours, perform Gau Seva, feed green grass, and attend Gau Aarti.",
      q4: "Is there a donation receipt provided?",
      a4: "Yes, an official digital receipt with tax exemption (80G) details is issued immediately after your successful transaction.",
      q5: "Can I sponsor for multiple years or special occasions?",
      a5: "Yes, multi-year programs (2, 5, and 10 years) are available. You can also dedicate your sponsorship in honor of birthdays, anniversaries, or in memory of loved ones.",
      q6: "What is the Gaushala Development Fund?",
      a6: "The Development Fund (₹6,000) directly supports infrastructure upgrades including modern shed construction, water storage tanks, and veterinary clinic equipment.",
    },
    cta: {
      heading: "Become a Part of Gau Seva",
      subtitle: "Support the care, nourishment, and lifelong protection of Gir cows through your contribution.",
      sponsorNow: "Sponsor Now",
    },
  },
  gruhUdhyog: {
    hero: {
      badge: "100% Pure & Handmade",
      brand: "Jivandhara Gruh Udhyog",
      title: "Handcrafted Goodness Made with Love & Tradition",
      subtitle: "Authentic Gujarati snacks, stone-ground spices, traditional pickles, sweets, and handcrafted items prepared by senior citizens and self-help groups. 100% proceeds go to elder care.",
      primaryCta: "Shop Products",
      secondaryCta: "Our Mission",
    },
    categories: {
      all: "All Products",
      snacks: "Handmade Snacks",
      pickles: "Pure Achar & Pickles",
      spices: "Ground Spices",
      sweets: "Traditional Sweets",
      handicrafts: "Artisan Handicrafts",
    },
    catalog: {
      eyebrow: "Our Products",
      heading: "Explore Our Handmade Collection",
      subtitle: "Made in hygienic small batches using pure ingredients and traditional recipes.",
      note: "Looking for custom bulk orders or festival gift hampers? ",
      contactUs: "Contact our team",
    },
    featured: {
      eyebrow: "Customer Favorites",
      heading: "Best Sellers & Featured Items",
      subtitle: "Loved by thousands of families across Gujarat and India.",
    },
    artisans: {
      eyebrow: "Empowering Lives",
      heading: "Stories of Our Senior Artisans",
      subtitle: "Every product tells a story of dignity, love, and passion.",
      quote: "Preparing these traditional recipes gives us happiness, companionship, and a sense of pride every single day.",
      a1Name: "Manjula Ben Shah",
      a1Craft: "Master Khakhra & Farsan Artisan",
      a1Years: "12 Years at Jivandhara",
      a2Name: "Saroj Ben Mehta",
      a2Craft: "Pickle & Chunda Specialist",
      a2Years: "9 Years at Jivandhara",
      a3Name: "Lilavati Ben Joshi",
      a3Craft: "Pure Spices & Sweets Expert",
      a3Years: "15 Years at Jivandhara",
    },
    by: "by",
    cta: {
      heading: "Support Dignity & Taste Authentic Goodness",
      body: "Order online today or contact us for festival bulk orders. 100% of proceeds fund food, medical care, and shelter for senior citizens.",
      support: "Support Our Mission",
      order: "Place Bulk / Festival Order",
    },
  },
  tiffinSeva: {
    hero: {
      eyebrow: "JIVANDHARA VRUDDHASHRAM INITIATIVE",
      title: "Senior Citizen & Community Tiffin Seva",
      subtitle:
        "Delivering warm, nutritious Satvik meals directly to the doorsteps of homebound seniors (60+ free on approval) and needy families (<60 with ₹100 fee).",
    },
    about: {
      eyebrow: "ABOUT THE INITIATIVE",
      title: "About Tiffin Seva",
      tagline:
        "Nourishing minds, bodies, and souls through selfless cooking, devotion, and compassion.",
      body: "The Tiffin Seva provides pure, hygienic, and Satvik meals to senior citizens, divyang individuals, and vulnerable families. Prepared under the spiritual guidance of Annapurna Bhojanshala, each tiffin is packed with hot rotlis, dal, rice, seasonal subzi, and buttermilk.",
      applyBtn: "Apply for Tiffin Seva",
      donateBtn: "Support & Donate",
    },
    specialization: {
      badge: "Our Core Strengths",
      title: "Tiffin Seva Specialization",
      desc: "Prepared with uncompromising hygiene, sacred culinary standards, and punctual delivery every day.",
      items: {
        jainFood: {
          title: "100% Jain Food",
          tagline: "Pure Satvik & Sacred",
          desc: "Strictly prepared without onions, garlic, or root vegetables (kandmool) in a clean, sanctified kitchen adhering to Jain dietary principles.",
          badge: "100% Jain",
        },
        delivery: {
          title: "Home Delivery",
          tagline: "Punctual Doorstep Service",
          desc: "Daily prompt delivery scheduled before 12:30 PM for lunch and before sunset for Chauvihar dinner, ensuring meals are enjoyed fresh and hot.",
          badge: "Punctual Daily",
        },
        regular: {
          title: "Regular Daily Tiffin",
          tagline: "365 Days Uninterrupted",
          desc: "Reliable, round-the-year daily service with zero disruption so that our senior citizens and dependent families never worry about a warm meal.",
          badge: "365 Days Active",
        },
        authentic: {
          title: "Best and Authentic Jain Food",
          tagline: "Wholesome & Traditional",
          desc: "Hot puffed Phulka Rotlis, aromatic Gujarati Dal, fragrant Basmati Rice, seasonal Subzi, and fresh Buttermilk made with devotion and care.",
          badge: "Authentic Taste",
        },
      },
    },
    registration: {
      senior: {
        badge: "Above 60 Years",
        tag: "Free / Trust Supported",
        title: "Senior Citizen Registration",
        desc: "Dedicated for elderly individuals and couples (age 60+) needing regular Satvik meals.",
        bullet1: "Zero registration fee (Fully supported by trust)",
        bullet2: "Subject to admin verification & approval",
        bullet3: "Hot Satvik lunch & dinner delivered to doorstep",
        btn: "Apply (Above 60 Years)",
      },
      general: {
        badge: "Below 60 Years",
        tag: "Fees: ₹100",
        title: "General / Needy Registration",
        desc: "For individuals under 60 years, differently-abled persons, or families needing meal assistance.",
        bullet1: "Nominal registration fee of ₹100 only",
        bullet2: "Quick processing with document verification",
        bullet3: "Pure vegetarian Satvik meals delivered daily",
        btn: "Apply (Below 60 Years - ₹100 Fee)",
      },
    },
    eligibility: {
      badge: "Who Can Benefit?",
      title: "Tiffin Seva Eligibility",
      cards: {
        senior: {
          title: "Senior Citizens (Aged 60+)",
          desc: "Elders living alone, unable to cook, or requiring daily Satvik diet support. Fully subsidized with trust support upon admin verification.",
          tag: "Free / Trust Sponsored",
        },
        general: {
          title: "General Registration (<60 Years)",
          desc: "Needy individuals, families, or differently-abled persons needing doorstep Satvik meal support.",
          tag: "Fees: ₹100",
        },
        divyang: {
          title: "Divyang (Differently Abled)",
          desc: "Physically challenged individuals needing home delivery of warm nutritious meals daily.",
          tag: "Doorstep Delivery",
        },
      },
    },
    howItWorks: {
      badge: "Simple 4-Step Process",
      title: "How Tiffin Seva Works",
      steps: {
        step1: {
          title: "Select Category",
          desc: "Choose Above 60 Years (Senior Seva) or Below 60 Years (₹100 Fee).",
        },
        step2: {
          title: "Fill Details",
          desc: "Provide applicant, family details, financial info, and upload ID proof.",
        },
        step3: {
          title: "Verification & Approval",
          desc: "Our coordinator reviews application and verifies delivery zone.",
        },
        step4: {
          title: "Tiffin Delivery Starts",
          desc: "Fresh hot Satvik meals delivered directly to your doorstep daily.",
        },
      },
    },
    modal: {
      title: "Apply for Tiffin Seva",
      subtitle: "Doorstep delivery of fresh, hygienic, and nutritious Satvik meals prepared with love and devotion.",
      badgeSenior: "Above 60 Years (Senior Seva)",
      badgeGeneral: "Below 60 Years (₹100 Fees)",
      categoryStep: {
        heading: "Select Registration Category",
        desc: "Please choose the beneficiary age group to continue with the Tiffin Seva registration.",
        seniorBadge: "Trust Supported",
        seniorTitle: "Above 60 Years (Senior Citizen)",
        seniorDesc: "Specially dedicated for senior citizens and elderly couples living alone or unable to cook.",
        seniorFee: "Free / Subsidized",
        seniorNote: "Subject to Admin Approval",
        generalBadge: "Fees: ₹100",
        generalTitle: "Below 60 Years (General / Needy)",
        generalDesc: "For individuals, differently-abled persons, or economically vulnerable families under 60.",
        generalFee: "Fees: ₹100",
        generalNote: "Instant Processing",
        qualityNote: "All meals are prepared in hygienic Satvik kitchen facilities under strict quality and cleanliness standards.",
      },
      successStep: {
        seniorTitle: "Application Submitted! Awaiting Admin Approval.",
        seniorDesc: "Our tiffin seva coordinator will verify the application details, residential location, and proof documents. We will contact you at",
        seniorDescEnd: "once approved.",
        generalFeeLabel: "Registration Fee: ₹100",
        generalTitle: "Tiffin Seva Application Submitted!",
        generalDesc: "Your registration for Tiffin Seva (Below 60 Years) has been recorded with a registration fee of",
        generalDescEnd: ". Delivery dispatch will commence as per schedule.",
        summaryTitle: "Application Summary",
        summaryAbove60: "Above 60 Years",
        summaryBelow60: "Below 60 Years",
        labelApplicant: "Applicant",
        labelMobile: "Mobile",
        labelTiffinPeriod: "Tiffin Period",
        labelFeeStatus: "Fee Status",
        feeFree: "Free (Trust Sponsored)",
        feePaid: "₹100 (Registration Fee)",
        immediate: "Immediate",
        to: "to",
        close: "Close",
        thankYou: "Thank you,",
      },
      formStep: {
        switchCategory: "Switch Category",
        categoryLabel: "Category:",
        seniorCategoryText: "Above 60 Years (Senior Citizen)",
        generalCategoryText: "Below 60 Years",
        registrationFeesBadge: "Registration Fees: ₹100",
        trustSponsoredBadge: "Trust Sponsored (Admin Approval)",
        section1Title: "Applicant Details",
        tiffinStartDate: "Tiffin Start Date",
        tiffinEndDate: "Tiffin End Date (Optional)",
        endDatePlaceholder: "Leave blank for ongoing",
        name: "Name",
        namePlaceholder: "Enter beneficiary / applicant full name",
        address: "Address",
        addressPlaceholder: "House / Flat No., Society / Street Name, Landmark, City & Pincode",
        age: "Age",
        agePlaceholderSenior: "e.g. 68 (Must be 60+)",
        agePlaceholderGeneral: "e.g. 42",
        gender: "Gender",
        male: "Male",
        female: "Female",
        other: "Other",
        dateOfBirth: "Date of Birth",
        mobileNo: "Mobile No.",
        section2Title: "Family Details",
        section2Desc: "List family members and household details",
        addFamilyMember: "Add Family Member",
        colName: "Name",
        colAge: "Age",
        colRelationship: "Relationship",
        colOccupation: "Occupation",
        colMobile: "Mobile",
        colAction: "Action",
        section3Title: "Financial & Other Details",
        monthlyIncome: "Family's Monthly Income",
        monthlyIncomePlaceholder: "e.g. ₹10,000 / month or Nil",
        tiffinRecipient: "Tiffin Recipient",
        tiffinRecipientPlaceholder: "e.g. Self, Elder Parents, Divyang Person",
        referenceName: "Reference Provider's Name",
        referenceNamePlaceholder: "Doctor / Neighbor / Trust Trustee / Social Worker",
        referenceMobile: "Reference Provider's Mobile No.",
        referenceAddress: "Reference Provider's Address",
        referenceAddressPlaceholder: "Address / Area",
        referenceOccupation: "Reference Provider's Occupation",
        referenceOccupationPlaceholder: "e.g. Doctor, Merchant, Social Worker",
        tiffinArrangement: "Tiffin Arrangement Details",
        tiffinArrangementPlaceholder: "e.g. Lunch Only, Dinner Only, Both Meals, Delivery time preference...",
        reasonForTiffin: "Reason for Providing Tiffin",
        reasonPlaceholder: "Explain situation: e.g. Senior living alone, physically unable to cook, financial difficulties, bedridden...",
        section4Title: "Proof of Identity",
        selectIdDocs: "Select Identity Documents Available:",
        aadhaar: "Aadhaar Card",
        rationCard: "Ration Card",
        voterId: "Election Card / Voter ID",
        uploadLabel: "Upload Identity Option (PDF / Photo)",
        uploadPrompt: "Upload Aadhaar / Ration / Voter ID",
        changeDoc: "Choose Different Document",
        back: "Back",
        cancel: "Cancel",
        submitting: "Submitting...",
        submitSenior: "Submit for Admin Approval",
        submitGeneral: "Submit Application (Pay ₹100)",
      },
      errors: {
        nameRequired: "Please enter applicant name",
        mobileRequired: "Please enter mobile number",
        addressRequired: "Please enter address",
        submitError: "Error submitting application. Please try again.",
        genericError: "Something went wrong. Please try again.",
      },
      toastSenior: "Your application is submitted. Wait for the admin approval.",
      toastGeneral: "Tiffin Seva application submitted. Fees: ₹100.",
    },
    toast: {
      error: "Could not submit",
      success: "Request submitted. Our team will contact you soon.",
    },
  },
  bhojanshala: {
    hero: {
      badge: "Sattvic Diet • Sacred Service",
      brand: "Bhojanshala",
      title: "Food Donation Is One of the Noblest Forms of Service",
      subtitle:
        "Support the Bhojanshala by sponsoring pure and wholesome meals and essential food services for devotees, pilgrims, senior citizens and visitors.",
      primaryCta: "Sponsor a Meal",
      secondaryCta: "View Sponsorship Options",
      imageAlt: "Sattvic meal thali served at the Bhojanshala",
    },
    about: {
      eyebrow: "About the Initiative",
      heading: "About the Bhojanshala",
      tagline:
        "Nourishing minds, bodies, and souls through selfless cooking and devotion.",
      body: "The Bhojanshala provides pure, hygienic and sattvic meals to pilgrims, devotees, senior citizens and visitors. Donors can support the Bhojanshala through different meal sponsorships and services, including Navkarshi, lunch, dinner, sweets, farsan, tiffin service, fruits and milk.",
    },
    schemes: {
      eyebrow: "Long-term Sponsorships",
      heading: "Permanent Meal Sponsorship",
      subtitle:
        "Permanent Bhojan Tithi sponsorship options for a period of 10 years.",
      sponsorNow: "Sponsor Now",
      lifetime: "Lifetime",
      empty: "Sponsorship schemes will appear here soon.",
    },
    packages: {
      eyebrow: "Individual & Holiday Services",
      heading: "Other Meal Sponsorship Options",
      subtitle:
        "Sponsor a complete meal day, festival feast, or holiday service for the Bhojanshala.",
      sponsorship: "Sponsorship",
      availableToday: "Available for today",
      nextAvailable: "Next available: Tomorrow",
      sponsorNow: "Sponsor Now",
      empty: "Meal packages will appear here soon.",
    },
    special: {
      eyebrow: "Dietary & Community Enrichments",
      heading: "Special Service Sponsorships",
      subtitle:
        "Provide specific items, health-supportive fruit, warm evening milk, or elder tiffin parcels.",
      availableToday: "Available for today",
      nextAvailable: "Next available: Tomorrow",
      sponsorNow: "Sponsor Now",
      empty: "Special services will appear here soon.",
    },
    note: {
      title: "Important Note",
      body: "The sponsorship amount for arranging a special sweet dish will be charged separately.",
    },
    supporting: {
      badge: "Supporting Donor • Sustained Help",
      heading: "Become a Bhojanshala Supporting Donor",
      body: "Contribute towards the regular services, maintenance and daily operations of the Bhojanshala by becoming a supporting donor.",
      contribution: "Contribution",
      amount: "₹9,000",
      amountLabel: "Sustaining Contribution",
      cta: "Become a Supporting Donor",
    },
    loading: "Loading Bhojanshala options…",
  },
};

export default programs;
